import { BrowserRouter, Routes, Route } from "react-router-dom";
import Tldraw from "./Tldraw";
import Excalidraw from "./Excalidraw";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Tldraw />} />
        <Route path="/2" element={<Excalidraw />} />
      </Routes>
    </BrowserRouter>
  );
}
